import { useMutation, useQueryClient } from "@tanstack/react-query";

import { callApi } from "../utils/ApiCallPostOnly";

export const useSaveOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "draftordercard",
        command: "save",
        data: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["draftOrder"] });
    },
  });
};
